/**
 * Download arbitrary data as a pretty-printed JSON file.
 * @param {any} data - payload to serialize
 * @param {string} filenameBase - without extension; timestamp is appended
 */
export const downloadJson = (data, filenameBase = 'export') => {
  const pretty = JSON.stringify(data, null, 2);
  const blob = new Blob([pretty], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filenameBase}-${ts}.json`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
